import { ActionReducer, Action } from '@ngrx/store';
import { FlightFinderInitState } from '../models/flight-finder.interface';

export const UPDATE_FLIGHT_QUOTE_DATA = 'UPDATE_FLIGHT_QUOTE_DATA';
export const UPDATE_FLIGHT_QUOTE_CACHE_REQUEST = 'UPDATE_FLIGHT_QUOTE_CACHE_REQUEST';
export const UPDATE_FLIGHT_QUOTE_RESULTS = 'UPDATE_FLIGHT_QUOTE_RESULTS';
export const UPDATE_PAGINATION_DATA = 'UPDATE_PAGINATION_DATA';
export const UPDATE_FLIGHT_CONNECTION_COUNT = 'UPDATE_FLIGHT_CONNECTION_COUNT';
export const INCREMENT_REQUEST_COUNT = 'INCREMENT_REQUEST_COUNT';
export const SET_REQUEST_LEGS = 'SET_REQUEST_LEGS';
export const SET_REQUEST_COUNT = 'SET_REQUEST_COUNT';
export const UPDATE_API_SEARCH = 'UPDATE_API_SEARCH';
export const UPDATE_FILTER_LEGS = 'UPDATE_FILTER_LEGS';
export const UPDATE_USER_SELECTED = 'UPDATE_USER_SELECTED';
export const UPDATE_DATALINK_SESSION = 'UPDATE_DATALINK_SESSION';
export const UPDATE_DATALINK_ERROR = 'UPDATE_DATALINK_ERROR';
export const UPDATE_FLIGHT_NUMBER_REQUEST = 'UPDATE_FLIGHT_NUMBER_REQUEST';
export const UPDATE_FLIGHT_NUMBER_RESULT = 'UPDATE_FLIGHT_NUMBER_RESULT';
export const UPDATE_REDIRECT_TO_SEARCH = 'UPDATE_REDIRECT_TO_SEARCH';
export const UPDATE_SESSION_USED = 'UPDATE_SESSION_USED';
export const UPDATE_SELECTED_MULTILEG_FLIGHT = 'UPDATE_SELECTED_MULTILEG_FLIGHT';
export const UPDATE_RETURN_SESSION_STRING = 'UPDATE_RETURN_SESSION_STRING';
export const UPDATE_RETURN_SESSION_ID = 'UPDATE_RETURN_SESSION_ID';
export const UPDATE_RETURN_CUSTOMER_URL = 'UPDATE_RETURN_CUSTOMER_URL';
export const UPDATE_PROMO_FROM_URL = 'UPDATE_PROMO_FROM_URL';
export const UPDATE_PRODUCT_TIER_FROM_URL = 'UPDATE_PRODUCT_TIER_FROM_URL';
export const UPDATE_CS_MOTO_FROM_URL = 'UPDATE_CS_MOTO_FROM_URL';
export const UPDATE_AIRLINE_SEARCH_STRING = 'UPDATE_AIRLINE_SEARCH_STRING';
export const RESET_FILTER_LEGS = 'RESET_FILTER_LEGS';
export const RESET_FLIGHT_QUOTE_DATA = 'RESET_FLIGHT_QUOTE_DATA';
export const RESET_FLIGHT_QUOTE_RESULTS = 'RESET_FLIGHT_QUOTE_RESULTS';
export const RESET_SELECTED_MULTILEG_FLIGHT = 'RESET_SELECTED_MULTILEG_FLIGHT';
export const REFRESH_FLIGHT_FINDER = 'REFRESH_FLIGHT_FINDER';
export const RESET_FLIGHT_FINDER = 'RESET_FLIGHT_FINDER';
export const SET_PRODUCT_TYPE = 'SET_PRODUCT_TYPE';
export const SAVE_OUTBOUND_ADDITIONAL_BAG_PRICE = 'SAVE_OUTBOUND_ADDITIONAL_BAG_PRICE';
export const SAVE_INBOUND_ADDITIONAL_BAG_PRICE = 'SAVE_INBOUND_ADDITIONAL_BAG_PRICE';
export const UPDATE_PREVIOUS_RESULT = 'UPDATE_PREVIOUS_RESULT';

export interface ActionWithPayloadInterface extends Action {
  payload: any;
}

const initState: FlightFinderInitState = {
  quoteFlightRequest: {
    departureAirport: null,
    toAirport: null,
    toCity: null,
    arrivalAirport: null,
    fromAirport: null,
    fromCity: null,
    airline: null,
    airlineName: null,
    departDate: null,
    bagCount: null,
    bagItems: {
      bags: 0,
      childEquipment: 0,
      oversizeItem: 0
    },
    flightDirection: null,
    flightNumber: null,
    optedInViaPod: false,
  },
  quoteFlightResults: [],
  quoteFlightCacheRequest: null,
  paginationFlightResponse: null,
  flightConnectionCount: 0,
  requestCount: 0,
  requestLegs: 0,
  searchMultiLegApi: false,
  filterLegs: {
    direct: true,
    oneStop: false,
    twoStop: false
  },
  userHasSelected: false,
  datalinkError: false,
  dataLinkSession: null,
  redirectToSearch: false,
  flightNumberSearchRequest: null,
  flightNumberSearchResult: [],
  sessionUsed: false,
  selectedMultiLegFlight: null,
  returnSessionString: null,
  returnSessionId: null,
  returnCustomerUrl: '',
  promoFromUrl: null,
  productTierFromUrl: null,
  csMotoFromUrl: false,
  selectedProductType: '',
  airlineSearchString: '',
  outboundAdditionBagPrice: 0,
  inboundAdditionBagPrice: 0,
  hasPreviousResults: false,
};

export function flightFinderReducer(state: FlightFinderInitState = initState, action: ActionWithPayloadInterface) {

  switch (action.type) {
    case UPDATE_FLIGHT_QUOTE_DATA:
      return Object.assign({}, state, { quoteFlightRequest: action.payload });

    case UPDATE_FLIGHT_QUOTE_CACHE_REQUEST:
      return Object.assign({}, state, { quoteFlightCacheRequest: action.payload });

    case UPDATE_FLIGHT_QUOTE_RESULTS:
      return Object.assign({}, state, { quoteFlightResults: action.payload });

    case UPDATE_PAGINATION_DATA:
      return Object.assign({}, state, { paginationFlightResponse: action.payload });

    case UPDATE_FLIGHT_CONNECTION_COUNT:
      return Object.assign({}, state, { flightConnectionCount: action.payload });

    case INCREMENT_REQUEST_COUNT:
      // return state.requestCount + 1;
      return Object.assign({}, state, { requestCount: state.requestCount + 1 });

    case SET_REQUEST_COUNT:
      return Object.assign({}, state, { requestCount: action.payload });

    case SET_REQUEST_LEGS:
      return Object.assign({}, state, { requestLegs: action.payload });

    case UPDATE_API_SEARCH:
      return Object.assign({}, state, { searchMultiLegApi: action.payload });

    case UPDATE_FILTER_LEGS:
      return Object.assign({}, state, { filterLegs: action.payload });

    case UPDATE_AIRLINE_SEARCH_STRING:
      return Object.assign({}, state, { airlineSearchString: action.payload });

    case UPDATE_USER_SELECTED:
      return Object.assign({}, state, { userHasSelected: action.payload });

    case UPDATE_DATALINK_ERROR:
      return Object.assign({}, state, { datalinkError: action.payload });

    case UPDATE_DATALINK_SESSION:
      return Object.assign({}, state, { dataLinkSession: action.payload });

    case UPDATE_FLIGHT_NUMBER_REQUEST:
      return Object.assign({}, state, { flightNumberSearchRequest: action.payload });

    case SET_PRODUCT_TYPE:
      return Object.assign({}, state, { selectedProductType: action.payload });

    case UPDATE_FLIGHT_NUMBER_RESULT:
      return Object.assign({}, state, { flightNumberSearchResult: action.payload });

    case UPDATE_REDIRECT_TO_SEARCH:
      return Object.assign({}, state, { redirectToSearch: action.payload });

    case UPDATE_SESSION_USED:
      return Object.assign({}, state, { sessionUsed: action.payload });

    case UPDATE_SELECTED_MULTILEG_FLIGHT:
      return Object.assign({}, state, { selectedMultiLegFlight: action.payload });

    case UPDATE_RETURN_SESSION_STRING:
      return Object.assign({}, state, { returnSessionString: action.payload });

    case UPDATE_RETURN_SESSION_ID:
      return Object.assign({}, state, { returnSessionId: action.payload });

    case UPDATE_RETURN_CUSTOMER_URL:
      return Object.assign({}, state, { returnCustomerUrl: action.payload });

    case UPDATE_PROMO_FROM_URL:
      return Object.assign({}, state, { promoFromUrl: action.payload });

    case UPDATE_PRODUCT_TIER_FROM_URL:
      return Object.assign({}, state, { productTierFromUrl: action.payload });

    case UPDATE_CS_MOTO_FROM_URL:
      return Object.assign({}, state, { csMotoFromUrl: action.payload });

    case SAVE_OUTBOUND_ADDITIONAL_BAG_PRICE:
      return Object.assign({}, state, { outboundAdditionBagPrice: action.payload });

    case SAVE_INBOUND_ADDITIONAL_BAG_PRICE:
      return Object.assign({}, state, { inboundAdditionBagPrice: action.payload });
    case UPDATE_PREVIOUS_RESULT:
      return Object.assign({}, state, { hasPreviousResults: action.payload });

    case RESET_FILTER_LEGS:
      return Object.assign({}, state, { filterLegs: initState.filterLegs });

    case RESET_FLIGHT_QUOTE_DATA:
      return Object.assign({}, state, { quoteFlightRequest: initState.quoteFlightRequest });

    case RESET_FLIGHT_QUOTE_RESULTS:
      return Object.assign({}, state, { quoteFlightResults: initState.quoteFlightResults });

    case RESET_SELECTED_MULTILEG_FLIGHT:
      return Object.assign({}, state, { selectedMultiLegFlight: null });

    case REFRESH_FLIGHT_FINDER:
      const refreshObj: FlightFinderInitState = Object.assign({}, action.payload);
      refreshObj.requestCount = 0;
      return refreshObj;

    case RESET_FLIGHT_FINDER:
      return Object.assign({}, initState);

    default:
      return state;
  }

};
